export default [

     {
          path: '/third-party-risk',
          name: 'ThirdPartyRisk',
          component: () => import("@/views/Page/ThirdPartyRisk/ThirdPartyRisk.vue"),
           meta: {
               title: 'ThirdPartyRisk',
          },
     }
];